import { default as React, useState, useEffect, useCallback, useRef } from "react";
import QueryGeneralInfo from "containers/property/QueryGeneralInfo";
import RecordHistory from "containers/common/RecordHistory";
import { PacmanLoader } from "react-spinners";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { get, post, put } from "aws-amplify/api";
import { Form, Row, Col, Button, Alert, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { createElementIdFactory } from "utils/elementIds";
import "react-datepicker/dist/react-datepicker.css";
import "containers/common/Detail.css";
import "containers/common/List.css";
import "containers/common/Table.css";

const initialQuery = {
    // Primary Identifiers
    query_id: "new",
    property_id: null,
    property_key: null,
    title_details: null,
    query_type_code: null,
    query_type: null,
    date_to_resolve: new Date(),
    entered_by: null,
    problem: null,
    active: false,
    doc_number: null,
    perpetual: false,

    // System fields
    modified: false,
    created_by: null,
    created_date: new Date(),
    last_edited_by: null,
    last_edited_date: null,
}

function QueryDetail({
    isAuthenticated,
    user,
    filter,
    saveForm,
    data,
    deleteRecord,
    salesheetid,
    validateRelatedRecord,
    propertyid
}) {
    const queryDetailIdPrefix = "query-detail";

    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const [queryType, setQueryType] = useState(null);
    const [query, setQuery] = useState(initialQuery);
    const latestQueryRef = useRef(initialQuery);
    const saveInFlightRef = useRef(false);
    const pendingSaveRef = useRef(false);
    const skipNextPagerBlurRef = useRef(false);
    const [activeTab, setActiveTab] = useState("query-detail");
    const createId = React.useMemo(
        () => createElementIdFactory(queryDetailIdPrefix),
        [queryDetailIdPrefix]
    );
    const property_key = params.property_key || params.propertyid || query.property_key;

    console.log(property_key)

    const [ui, setUi] = useState({
        isLoading: params.id !== 'new',
        isSaving: false,
        isIndexLoading: false,
        isDeleting: false,
        showAlert: false,
        errorMessage: ""
    });
    const [nav, setNav] = useState({
        previousId: null,
        nextId: null,
        currentIdIndex: null,
        idList: [],
        propertyidlist: []
    });
    const [currentIdInput, setCurrentIdInput] = useState("");
    console.log("DEBUG USER:", user);

    const getQueryTypes = useCallback(async () => {
        try {
            const response = await get({
                apiName: "colin",
                path: "/querytypes",
            }).response;
            const options = await response.body.json();
            setQueryType(options);
        } catch (err) {
            console.error("Error getting query types:", err);
        }
    }, []);

    const saveQueryAPI = useCallback(async (data) => {
        const isNew = data.query_id === "new";
        const pKey = data.property_key || property_key;
        const qId = data.query_id;

        const path = isNew
            ? `/properties/${pKey}/queries/new`
            : `/properties/${pKey}/queries/${qId}`;

        const method = isNew ? post : put;

        try {
            const response = await method({
                apiName: "colin",
                path: path,
                options: {
                    body: data
                }
            }).response;

            const result = await response.body.json();
            return result;
        } catch (error) {
            console.error("API Save Error:", error);
            throw error;
        }
    }, [property_key]);

    // --- Effect Hook --
    const loadAllQueryData = useCallback(async () => {
        setUi(prev => ({ ...prev, isLoading: true }));

        try {
            await getQueryTypes();

            if (params.id === "new") {
                setQuery({
                    ...initialQuery,
                    property_key: property_key,
                    property_id: property_key,
                    active: true,
                    created_by: user || "",
                    entered_by: user || "",
                });
            } else {
                // For existing queries, fetch from API using the current property_key
                const pKey = property_key;
                const path = `/properties/${pKey}/queries/${params.id}`;
                try {
                    const response = await get({
                        apiName: "colin",
                        path: path,
                    }).response;

                    const localQuery = await response.body.json();
                    setQuery(prev => ({ ...initialQuery, ...localQuery }));
                } catch (e) {
                    console.error("Error fetching query:", e);
                    setUi(prev => ({ ...prev, errorMessage: "Failed to load query", showAlert: true }));
                }
            }
        } catch (error) {
            setUi(prev => ({ ...prev, errorMessage: "Failed to load", showAlert: true }));
        } finally {
            setUi(prev => ({ ...prev, isLoading: false }));
        }
    }, [params.id, property_key, user, getQueryTypes]);

    useEffect(() => {
        if (isAuthenticated) {
            loadAllQueryData();

            if (nav.idList && nav.idList.length > 0) {
                const currentIndex = nav.idList.findIndex(item => String(item) === String(params.id));
                
                if (currentIndex !== -1) {
                    setNav(prev => ({
                        ...prev,
                        previousId: currentIndex > 0 ? nav.idList[currentIndex - 1] : null,
                        nextId: currentIndex < nav.idList.length - 1 ? nav.idList[currentIndex + 1] : null,
                        currentIdIndex: currentIndex
                    }));
                    setCurrentIdInput(String(currentIndex + 1));
                } else {
                    setNav(prev => ({
                        ...prev,
                        previousId: null,
                        nextId: null,
                        currentIdIndex: null
                    }));
                    setCurrentIdInput("");
                }
            }
            document.title = "Queries Queue";
            document.title = property_key + " query";
        }
    }, [isAuthenticated, loadAllQueryData, params.id, nav.idList, property_key]);

    useEffect(() => {
        if (location.state && location.state.data) {
            setNav(prev => ({
                ...prev,
                idList: location.state.data,
                propertyidlist: location.state.propertyidlist || []
            }));
        }
    }, [location.state]);
    //     componentWillReceiveProps(prevProps) {
    //         if (prevProps.location.pathname !== location.pathname) {
    //             // Clean component and reload?
    //             console.log("Resetting");
    //             window.location.reload();
    //         }
    //     }

    useEffect(() => {
        if (params.id === "new" && params.propertyid) {
            setQuery(prev => ({
                ...prev,
                property_key: params.propertyid,
                property_id: params.propertyid
            }));

            document.title = params.propertyid + " - New Query";
        }
    }, [params.id, params.propertyid]);

    useEffect(() => {
        latestQueryRef.current = query;
    }, [query]);

    // --- Input Change Handlers ---
    const handleChange = (e, fieldName) => {
        if (e?.target) {
            const { name, value, type, checked } = e.target;
            setQuery(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value,
                modified: true
            }));
        } else {
            setQuery(prev => ({
                ...prev,
                [fieldName]: e,
                modified: true
            }));
        }
    };

    const handleBlur = useCallback(async () => {
        if (saveInFlightRef.current) {
            pendingSaveRef.current = true;
            return;
        }

        const currentQuery = latestQueryRef.current;
        if (!currentQuery?.modified) {
            return;
        }

        try {
            saveInFlightRef.current = true;
            setUi(prev => ({ ...prev, showAlert: false, isSaving: true }));

            // Validation check
            if (!currentQuery.query_type_code) {
                setUi(prev => ({ 
                    ...prev, 
                    errorMessage: "Query type cannot be empty. The record has not been saved",
                    showAlert: true,
                    isSaving: false
                }));
                return;
            }

            // Mark clean before save to avoid duplicate create requests from quick blur chains.
            setQuery(prev => ({ ...prev, modified: false }));
            const isNewRecord = currentQuery.query_id === "new";

            // Prepare payload with metadata
            const payload = {
                ...currentQuery,
                last_edited_by: user || "Unknown User",
                last_edited_date: new Date().toISOString(),
                modified: false
            };

            // Save via API
            const result = await saveQueryAPI(payload);

            if (result && result.result === false) {
                setUi(prev => ({
                    ...prev,
                    errorMessage: result.error_message || "Save failed",
                    showAlert: true,
                    isSaving: false
                }));
            } else {
                setQuery(prev => ({ ...prev, ...result, modified: false }));

                // If it was a new query, update the URL with the new ID
                if (isNewRecord && result.id) {
                    setQuery(prev => ({ ...prev, query_id: result.id }));
                    navigate(`/properties/${property_key}/queries/${result.id}`, {
                        state: { 
                            data: nav.idList,
                            propertyidlist: nav.propertyidlist || []
                        }
                    });
                }

                setUi(prev => ({ ...prev, isSaving: false }));
            }
        } catch (e) {
            console.error("Save failed", e);
            setUi(prev => ({
                ...prev,
                errorMessage: e.message || "Save failed. Please refresh and try again.",
                showAlert: true,
                isSaving: false
            }));
        } finally {
            saveInFlightRef.current = false;

            if (pendingSaveRef.current) {
                pendingSaveRef.current = false;
                if (latestQueryRef.current?.modified) {
                    setTimeout(() => {
                        handleBlur();
                    }, 0);
                }
            }
        }
    }, [user, property_key, navigate, saveQueryAPI, nav.idList, nav.propertyidlist]);

    const handleDelete = useCallback(async (event) => {
        if (event) event.preventDefault();

        if (query.registered) {
            window.alert("Lease records cannot be deleted");
            return;
        }

        const confirmed = window.confirm("Are you sure you want to delete this query?");
        if (!confirmed) return;

        try {
            setUi(prev => ({ ...prev, isSaving: true }));

            const archivedPayload = {
                ...query,
                active: false,              
                archived_date: new Date().toISOString(), 
                last_edited_by: user || "Unknown User",
                last_edited_date: new Date().toISOString(),
                modified: false
            };

            const result = await saveQueryAPI(archivedPayload);

            if (result && result.result === false) {
                alert(result.error_message || "Delete failed");
                setUi(prev => ({ ...prev, isSaving: false }));
            } else {
                // Successfully archived, navigate back to the property page root
                const targetPropertyKey = archivedPayload.property_key || property_key;
                navigate(`/properties/${targetPropertyKey}`);
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert("Failed to delete. Please refresh and try again.");
            setUi(prev => ({ ...prev, isSaving: false }));
        }
    }, [query, property_key, user, navigate, saveQueryAPI]);

    const handleGoToRecord = () => {
        const isWholePage = /^\d+$/.test(currentIdInput);
        const pageNumber = isWholePage ? Number.parseInt(currentIdInput, 10) : Number.NaN;
        const targetId = nav.idList[pageNumber - 1];

        if (targetId === undefined) {
            setCurrentIdInput(String(nav.currentIdIndex + 1));
            alert("Page no not in range.");
            return;
        }

        navigate(`/properties/${property_key}/queries/${targetId}`, {
            state: { data: nav.idList, propertyidlist: nav.propertyidlist }
        });
    };

    const handlePagerBlur = () => {
        if (skipNextPagerBlurRef.current) {
            skipNextPagerBlurRef.current = false;
            return;
        }

        handleGoToRecord();
    };

    const handleEnterCurrentIdIndex = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            skipNextPagerBlurRef.current = true;
            handleGoToRecord();
            event.currentTarget.blur();
        }
    };

    const handleBackToProperty = useCallback(() => {
        const targetPropertyKey = query.property_key || property_key || params.propertyid;
        if (!targetPropertyKey) {
            return;
        }

        navigate(`/properties/${targetPropertyKey}/#queries`, {
            state: {
                forceShowLoader: true,
                fromQueryDetail: true,
            },
        });
    }, [navigate, params.propertyid, property_key, query.property_key]);

    // --- Render Functions ---
    function renderForm() {
        const querySummary = `Query Details - ${query.property_key || ""}${query.title_details ? ` - ${query.title_details}` : ""}`;

        return (
            <div className="query" id={createId("container") }>
                {query && (
                    <div className="QueryForm">
                        {ui.showAlert && (
                            <Alert id={createId("alert", "error")} variant="danger" dismissible onClose={() => setUi(prev => ({ ...prev, showAlert: false }))}>
                                {ui.errorMessage}
                            </Alert>
                        )}
                        <div id={createId("actions")} className="d-flex justify-content-end gap-1 mt-2 mt-md-0 mb-2">
                                    <Button
                                        id={createId("action", "back-to-property")}
                                        variant="primary"
                                        type="button"
                                        size="sm"
                                        onClick={handleBackToProperty}
                                    >
                                        Back to Property {property_key}
                                    </Button>
                                    <Link to={`/properties/${property_key}/queries/new`}>
                                        <Button id={createId("action", "add")} variant="secondary" type="button" size="sm">Add</Button>
                                    </Link>
                                    <Button
                                        id={createId("action", "delete")}
                                        variant="danger"
                                        onClick={handleDelete}
                                        type="button"
                                        size="sm"
                                        disabled={ui.isSaving}
                                    >Delete</Button>
                                </div>
                        {nav.currentIdIndex !== null && nav.idList.length > 0 && (
                            <Nav className="justify-content-center align-items-center flex-wrap mb-2">
                                {nav.previousId !== null && (
                                    <Nav.Item className="d-flex align-items-center mr-1 mb-2">
                                        <Button variant="info" size="sm" type="button" className="d-flex align-items-center justify-content-center" style={{ whiteSpace: "nowrap" }} onClick={() => navigate(`/properties/${property_key}/queries/${nav.previousId}`, { state: { data: nav.idList, propertyidlist: nav.propertyidlist } })}>
                                            Previous
                                        </Button>
                                    </Nav.Item>
                                )}
                                {nav.nextId !== null && (
                                    <Nav.Item className="d-flex align-items-center mr-1 mb-2">
                                        <Button variant="info" size="sm" type="button" className="d-flex align-items-center justify-content-center" style={{ whiteSpace: "nowrap" }} onClick={() => navigate(`/properties/${property_key}/queries/${nav.nextId}`, { state: { data: nav.idList, propertyidlist: nav.propertyidlist } })}>
                                            Next
                                        </Button>
                                    </Nav.Item>
                                )}
                                <Form.Group as={Row} controlId="currentIdIndex" className="mb-1">
                                    <Col className="zeroPadRight">
                                        <Form.Control
                                            value={currentIdInput}
                                            onChange={(event) => setCurrentIdInput(event.target.value)}
                                            onBlur={handlePagerBlur}
                                            onKeyDown={handleEnterCurrentIdIndex}
                                            as="input"
                                            type="text"
                                            min="0"
                                            className="pageCount"
                                        />
                                    </Col>
                                    <Col className="zeroPadLeft">
                                        <h6>
                                            <div className="topPad">of {nav.idList.length} </div>
                                        </h6>
                                    </Col>
                                </Form.Group>
                            </Nav>
                        )}
                        <Form id={createId("form")}>
                            <div
                                id={createId("header", "row")}
                                className="d-flex flex-wrap justify-content-between align-items-end mt-3"
                            >
                                <Nav
                                    id={createId("tabs")}
                                    variant="tabs"
                                    activeKey={activeTab}
                                    onSelect={(selectedKey) => setActiveTab(selectedKey || "query-detail")}
                                >
                                    <Nav.Item id={createId("tab", "query-detail", "item")}>
                                        <Nav.Link id={createId("tab", "query-detail")} eventKey="query-detail">Query Detail</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item id={createId("tab", "record-history", "item")}>
                                        <Nav.Link id={createId("tab", "record-history")} eventKey="record-history">Record History</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>

                            <div
                                id={createId("summary")}
                                className="text-start"
                                style={{
                                    padding: ".75rem 1.25rem",
                                    border: "1px solid #ced4da",
                                    borderTop: 0,
                                    backgroundColor: "#80BFFF26",
                                    fontSize: "11px",
                                }}
                            >
                                {querySummary}
                            </div>

                            <div id={createId("content")} style={{ border: "1px solid #ced4da", borderTop: 0, padding: "12px", backgroundColor: "#fff" }}>
                                {activeTab === "query-detail" && (
                                    <QueryGeneralInfo
                                        queryData={query}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        queryTypeOptions={queryType}
                                        user={user}
                                        createId={createId}
                                    />
                                )}

                                {activeTab === "record-history" && (
                                    <RecordHistory
                                        created_date={query.created_date}
                                        created_by={query.created_by}
                                        last_edited_date={query.last_edited_date}
                                        last_edited_by={query.last_edited_by}
                                    />
                                )}
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        );
    };

    function renderComponent() {
        return (
            <div className="componentRendering">
                <Row className="show-Container">
                    <Col sm={12} md={12} lg={12}>
                        {ui.isLoading && (
                            <div className="outer-div">
                                <div className="sweet-loading inner-div">
                                    <PacmanLoader
                                        cssOverride={{ display: "block", margin: "0 auto" }}
                                        size={20}
                                        color={"#e03c31"}
                                        loading={ui.isLoading}
                                    />
                                </div>
                            </div>
                        )}
                        {!ui.isLoading && query
                            ? renderForm()
                            : null
                        }
                    </Col>
                </Row>
            </div>
        );
    }
    return (
        <div className="QueryDetail">
            {isAuthenticated ? renderComponent() : console.log("User not authenticated, no render")}
        </div>
    );
}

export default QueryDetail;